@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  top: 0;
  left: 0;
  z-index: 3;
  position: fixed;
}

.ideasWrapper {
  display: flex;
  flex-direction: column;
  transition: opacity 0.2s ease-in-out;

  &.focused {
    padding: 20px 0;
    border-radius: 10px;
    border: 1px solid var(--light-60);
    background: rgba(0, 0, 0, 0.01);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  }

  &.hidden {
    opacity: 0;
    pointer-events: none;
  }

  .promptInput {
    border-radius: 8px;
    box-shadow: 0 9px 24px 0 var(--dark-7), 0 0 4px 0 var(--dark-8), 0 2px 10px 0 var(--dark-6);
  }
}

.fields {
  gap: 28px;
  margin: 0;
  max-width: 100%;

  @include for-phone-only {
    padding: 12px 0;
  }

  .fieldContainer,
  .buttonsContainer {
    width: 100%;
    display: flex;
    padding: 0 20px;

    @include for-phone-only {
      padding: 0 12px;
    }
  }

  .pillsInputContainer {
    width: 100%;
    display: flex;

    > div > div > div:first-child {
      padding-left: 20px;

      @include for-phone-only {
        padding-left: 12px;
      }
    }

    > div > div > div:last-child > div {
      padding-left: 20px;

      @include for-phone-only {
        padding-left: 12px;
      }
    }
  }
}
